import React, { useEffect, useState } from "react";
import { Row, Col, Card, ProgressBar, Modal } from "react-bootstrap";
import Sidebar from "./Sidebar";
import "../styles/Dashboard.css";
import { Outlet, useLocation } from "react-router-dom";
import { authService } from "../services";
import { Spinner } from "react-bootstrap";

const Dashboard = () => {
  const location = useLocation();
  const responseData = location.state;

  const [isOpen, setIsOpen] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [quadrenetProfile, setQuadrenetProfile] = useState("");
  const [discount, setDiscount] = useState([]);

  const [loading, setLoading] = useState(true);

  const toggleSidebar = () => setIsOpen(!isOpen);
  const handleCloseModal = () => setShowModal(false);
  const handleShowModal = () => setShowModal(true);




  const silverTypes = [
    "Corporate Silver",
    "Friends of Evolv S20",
    "Friends of Evolv S50",
    "Friends of Staff",
    "Silver",
    "Staff",
  ];

  useEffect(() => {
    getQuadranetProfileDetails();
    console.log("responseData", location.state);
  }, []);

  //************* Fetch_QuadranetProfile_List *************
  const getQuadranetProfileDetails = async () => {
    try {
      setLoading(true);
      const res = await authService.getQuadranetProfile();
      if (res && res.data) {
        setQuadrenetProfile(res.data);
        await UpdateTierApi(res.data);
      }
    } catch (error) {
      console.log("Error fetching rewards list");
    } finally {
      setLoading(false);
    }
  };

  //************* Update Type *************
  const UpdateTierApi = async (quadrenetProfile) => {
    try {
      const payload = {
        points: quadrenetProfile?.points?.balance?.totalPoints,
        tierName: quadrenetProfile?.user?.profile?.membershipType,
      };
      const res = await authService.updateTireAPi(payload);
      if (res && res.data) {
        setDiscount(res.data);
      }
    } catch (error) {
      console.log("Error fetching location list");
    }
  };

  //************* CARDS THREE *************
  const membershipType = quadrenetProfile?.user?.profile?.membershipType;
  const fullName =
    quadrenetProfile?.user?.profile?.forename +
    " " +
    quadrenetProfile?.user?.profile?.surname;
  const swipeNo = quadrenetProfile?.user?.profile?.swipeNo || "Swipe No";
  const totalPoints = quadrenetProfile?.points?.balance.totalPoints || "0";

// ****** Not showing for black Cardd *********
const showProgressBar = 
  membershipType === "Bluebird Club" || silverTypes.includes(membershipType);

  return (
    <div
      className={`dashboard-container ${
        isOpen ? "sidebar-open" : "sidebar-closed"
      }`}
    >
      <Sidebar isOpen={isOpen} toggleSidebar={toggleSidebar} />

      <div className="content-area">
        {/************** Member Card Styled like a Credit Card **************/}
        <Row className="align-items-center">
          {loading ? (
            <Col md={12} className="text-center my-5">
              <Spinner animation="border" style={{ color: "#4a235a" }} />
            </Col>
          ) : (
            <>
              {membershipType === "Bluebird Club" ? (
                <Col md={5}>
                  <Card className="bluebird-card">
                    <Card.Body className="p-0">
                      <h4 style={{ fontSize: "22px", color: "#FFFFFF" }}>
                        {fullName}
                      </h4>
                      <p
                        style={{ fontSize: "16px", color: "#FFFFFF" }}
                        className="member-id"
                      >
                        {swipeNo}
                      </p>
                      <p className="points">
                        <span style={{ fontSize: "25px", color: "#FFFFFF" }}>
                          {totalPoints}
                        </span>
                        <span
                          style={{
                            fontSize: "16px",
                            color: "#FFFFFF",
                            display: "block",
                          }}
                        >
                          Points
                        </span>
                      </p>
                    </Card.Body>
                    <p
                      className="discount"
                      style={{
                        position: "absolute",
                        right: "15px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        color: "#2F0742",
                        fontWeight: "normal",
                      }}
                    >
                      {discount.discountAmount}
                    </p>
                  </Card>
                </Col>
              ) : silverTypes.includes(membershipType) ? (
                <Col md={5}>
                  <Card className="member-card">
                    <Card.Body className="p-0">
                      <h4 style={{ fontSize: "22px", color: "#2F0742" }}>
                        {fullName}
                      </h4>
                      <p
                        style={{ fontSize: "16px", color: "#2F0742" }}
                        className="member-id"
                      >
                        {swipeNo}
                      </p>
                      <p className="points">
                        <span style={{ fontSize: "25px", color: "#2F0742" }}>
                          {totalPoints}
                        </span>
                        <span
                          style={{
                            fontSize: "16px",
                            color: "#2F0742",
                            display: "block",
                          }}
                        >
                          Points
                        </span>
                      </p>
                    </Card.Body>
                    <p
                      className="discount"
                      style={{
                        position: "absolute",
                        right: "15px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        color: "#2F0742",
                        fontWeight: "normal",
                      }}
                    >
                      {discount.discountAmount}
                    </p>
                  </Card>
                </Col>
              ) : (
                <Col md={5}>
                  <Card className="black-card">
                    <Card.Body className="p-0">
                      <h4 style={{ fontSize: "22px", color: "#FFFFFF" }}>
                        {fullName}
                      </h4>
                      <p
                        style={{ fontSize: "16px", color: "#FFFFFF" }}
                        className="member-id"
                      >
                        {swipeNo}
                      </p>
                      <p className="points">
                        <span style={{ fontSize: "25px", color: "#FFFFFF" }}>
                          {totalPoints}
                        </span>
                        <span
                          style={{
                            fontSize: "16px",
                            color: "#FFFFFF",
                            display: "block",
                          }}
                        >
                          Points
                        </span>
                      </p>
                    </Card.Body>
                    <p
                      className="discount"
                      style={{
                        position: "absolute",
                        right: "15px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        color: "#FFFFFF",
                        fontWeight: "normal",
                      }}
                    >
                      {discount.discountAmount}
                    </p>
                  </Card>
                </Col>
              )}

              {/************** Progress Bar Outside the Card in the Same Row **************/}
              {/* <Col md={7} className="d-flex flex-column align-items-center">
                <div className="progress-bar-new">
                  <ProgressBar
                    className="custom-progress-bar"
                    max={5000}
                    // now={quadrenetProfile?.points?.balance.totalPoints || 0}
                    now={
                      quadrenetProfile?.user?.profile?.membershipType ===
                      "Black"
                        ? 5000
                        : quadrenetProfile?.points?.balance.valueofPoints || 0
                    }
                  />
                  <div className="iMainLyout">
                    <h6 className="progress-title mt-2">
                      {" "}
                      {quadrenetProfile?.user?.profile?.membershipType ===
                      "Black"
                        ? "Black Card Attained"
                        : "Progress to Black Card"}
                    </h6>

                    {quadrenetProfile?.user?.profile?.membershipType !==
                      "Black" && (
                      <div className="popup-i-bt1">
                        <button
                          className="btn btn-sm btn-outline-light i-bt11"
                          onClick={handleShowModal}
                        >
                          i
                        </button>
                      </div>
                    )}
                  </div>
                </div>
              </Col> */}
            <Col md={7} className="d-flex flex-column align-items-center">
  {showProgressBar ? (
    <div className="progress-bar-new">
      <ProgressBar
        className="custom-progress-bar"
        max={5000}
        now={
          quadrenetProfile?.user?.profile?.membershipType === "Black"
            ? 5000
            : quadrenetProfile?.points?.balance.valueofPoints || 0
        }
      />
      <div className="iMainLyout">
        <h6 className="progress-title mt-2">
          {quadrenetProfile?.user?.profile?.membershipType === "Black"
            ? "Black Card Attained"
            : "Progress to Black Card"}
        </h6>

        {quadrenetProfile?.user?.profile?.membershipType !== "Black" && (
          <div className="popup-i-bt1">
            <button
              className="btn btn-sm btn-outline-light i-bt11"
              onClick={handleShowModal}
            >
              i
            </button>
          </div>
        )}
      </div>
    </div>
  ) : (
    <div className="progress-bar-new d-flex flex-column justify-content-center align-items-center text-center" style={{ height: "100%" }}>
      {/* <h6 className="progress-title mt-2 text-white">
        Your VIP WhatsApp Helpline (9am–9pm)
      </h6> */}
      <a
        href="https://wa.me/447353005013"
        target="_blank"
        rel="noopener noreferrer"
       className="text-black mt-2 font-normal"
      >
        Your VIP WhatsApp Helpline (9am–9pm)
      </a>
    </div>
  )}
</Col>

          
            </>
          )}
        </Row>

        <Outlet />

        {/************** Modal **************/}
        <Modal
          show={showModal}
          onHide={handleCloseModal}
          className="design222"
          centered
        >
          <div className="all-modal-design">
            <div className="iconIII">
              <button className="modelibutton">i</button>
            </div>

            <h4>How to reach Black Card</h4>
            <p>
              Guests spending more than £5,000 in the preceding 12-month period
              qualify for our exclusive Black Card.
            </p>
            <button
              className="btn btn-primary"
              onClick={() => setShowModal(false)}
            >
              Close
            </button>
          </div>
        </Modal>
      </div>
    </div>
  );
};

export default Dashboard;
